import { Fragment, useState } from "react";
import { 
  Dialog, 
  DialogPanel, 
  DialogTitle,
  Transition, 
  TransitionChild,
} from "@headlessui/react";
import { 
  XMarkIcon,
  PlusIcon
} from "@heroicons/react/24/outline";
import { 
  Button, 
  Input, 
  Checkbox,
} from "components/ui";

export function AddTaxRateModal({ show, onClose }) {
  const [rows, setRows] = useState([
    { id: 1, name: "", percentage: "0.00000", agency: "" }
  ]);

  const addRow = () => {
    setRows([...rows, { id: Date.now(), name: "", percentage: "0.00000", agency: "" }]);
  };

  const removeRow = (id) => {
    if (rows.length > 1) {
      setRows(rows.filter(row => row.id !== id));
    }
  };

  return (
    <Transition show={show} as={Fragment}>
      <Dialog as="div" className="relative z-[420]" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity dark:bg-black/60" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 overflow-hidden text-left">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative flex w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all dark:bg-dark-700 border border-slate-100 dark:border-dark-600 isolate">
                {/* Header */}
                <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4 dark:border-dark-600 bg-slate-50/50">
                  <DialogTitle className="text-lg font-bold text-slate-900 dark:text-white">
                    Tax rate
                  </DialogTitle>
                  <button
                    onClick={onClose}
                    className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-500 dark:text-dark-300 dark:hover:bg-dark-600"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="p-8 space-y-6">
                  <div className="space-y-4">
                    <div className="grid grid-cols-12 gap-4 px-1">
                        <div className="col-span-6"><label className="text-xs font-bold text-slate-700 dark:text-dark-200">Rate name</label></div>
                        <div className="col-span-2"><label className="text-xs font-bold text-slate-700 dark:text-dark-200">Percentage</label></div>
                        <div className="col-span-4"><label className="text-xs font-bold text-slate-700 dark:text-dark-200">Tax agency</label></div>
                    </div>
                    {rows.map((row) => (
                        <div key={row.id} className="grid grid-cols-12 gap-4 items-start">
                            <div className="col-span-6">
                                <Input placeholder="" defaultValue={row.name} className="h-10" />
                            </div>
                            <div className="col-span-2">
                                <Input type="number" suffix="%" defaultValue={row.percentage} className="h-10" />
                            </div>
                            <div className="col-span-3">
                                <Input placeholder="" defaultValue={row.agency} className="h-10" />
                            </div>
                            <div className="col-span-1 pt-2.5">
                                <button 
                                    onClick={() => removeRow(row.id)}
                                    className="text-slate-400 hover:text-slate-600 transition-colors"
                                >
                                    <XMarkIcon className="h-5 w-5" />
                                </button>
                            </div>
                        </div>
                    ))}
                  </div>

                  <button 
                    onClick={addRow}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-primary-100 bg-primary-50/50 text-xs font-bold text-primary hover:bg-primary-50 transition-all dark:bg-primary-500/10 dark:border-primary/20"
                  >
                    <PlusIcon className="h-4 w-4" /> Add rate
                  </button>

                  <div className="pt-2 pl-1">
                    <Checkbox label="Active" defaultChecked color="primary" classNames={{ labelText: "text-sm font-semibold text-slate-700 dark:text-dark-200" }} />
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4 dark:border-dark-600 dark:bg-dark-750/50">
                  <Button variant="flat" onClick={onClose} className="font-bold text-xs px-6 h-9">
                    Cancel
                  </Button>
                  <Button variant="filled" color="primary" onClick={onClose} className="font-bold text-xs px-8 h-9">
                    Save
                  </Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
